import {GetBasketPageBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.types';
import {useCallback} from 'react';
import {useBasketTotalsSection} from './useGetBasketPageSection';

export const useUpdateBasketSectionsCallback = () => {
  const config = {disabled: true};
  const basketTotalsSectionRequest = useBasketTotalsSection(config);

  return useCallback(
    (sections: GetBasketPageBulkResponse) => {
      /**
       * its only possible to update the cache of the whole page bulk data.
       * We can use any individual section hook to update the cache of the whole page bulk data.
       * NOTE: using `useBasketTotalsSection` for no particular reason. Any section hook can be used.
       */
      basketTotalsSectionRequest.updateCache(sections);
    },
    [basketTotalsSectionRequest],
  );
};
